import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SideBar from "../other/SideBar";
import NavBar from "../other/NavBar";

import Notification from "../other/Notification";

const Reports = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [toggleSideBar, setToggleSideBar] = useState(false);
  const [canvas, setCanvas] = useState(false);

  const handleToggleSidebar = (e) => {
    e.preventDefault();
    setToggleSideBar(!toggleSideBar);
  };

  const handleToggleOffCanvas = (e) => {
    e.preventDefault();
    setCanvas(!canvas);
  };

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/auth");
    }
  }, [navigate]);

  useEffect(() => {
    setToken(localStorage.getItem("token"));
  }, [token]);



  return (
    <>
      {token && (
        <>
          <div
            className={
              toggleSideBar
                ? "container-scroller sidebar-icon-only"
                : "container-scroller"
            }
          >
            <nav className="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">
              <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
                <Link className="navbar-brand brand-logo-mini" to="/fooders_cp">
                  {/* <img src="images/mini-kr-logo.svg" alt="logo" />     */}
                </Link>
                <div className="me-1">
                  <button
                    className={
                      toggleSideBar
                        ? "navbar-toggler navbar-toggler align-self-center"
                        : "navbar-toggler navbar-toggler align-self-center text-white"
                    }
                    type="button"
                    onClick={handleToggleSidebar}
                  >
                    <span className="icon-menu"></span>
                  </button>
                </div>
                <div>
                  <Link to="/fooders_cp">
                    <span className="navbar-brand brand-logo">
                      <img src="images/vyfoo_logo.png" alt="logo" />
                    </span>
                  </Link>
                </div>
              </div>
              <NavBar handleToggle={handleToggleOffCanvas} toggleCanvas={toggleSideBar} />
            </nav>
            <div className="container-fluid page-body-wrapper px-0">
              <SideBar active="reports" toggleCanvas={toggleSideBar} />

              <div className="main-panel">
                <div className="content-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <h3 className="ukhd mb-3">Reports</h3>
                      <div className="row flex-grow">
                        <div className="col-4 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body ">
                              <div className="row text-center">
                                <h4 className="mb-2">Taxes</h4>
                              </div>
                              <div className="row">
                                <div className="list-group">
                                  <Link
                                    to="/gst_report"
                                    className="list-group-item"
                                  >
                                    <h5 className="list-group-item-heading mb-0">
                                      Tax Summary
                                    </h5>
                                    <p className="list-group-item-text mb-0">
                                      View total tax collected for the selected period.
                                    </p>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>


                        <div className="col-4 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body ">
                              <div className="row text-center">
                                <h4 className="mb-2">Sales</h4>
                              </div>
                              <div className="row">
                                <div className="list-group">
                                  <Link
                                    to="/reports_by_daily_sales"
                                    className="list-group-item"
                                  >
                                    <h5 className="list-group-item-heading mb-0">
                                      Daily Sales
                                    </h5>
                                    <p className="list-group-item-text mb-0">
                                      View total sales, items sold, discounts, and revenue for a selected day.
                                    </p>
                                    {/* <p className="list-group-item-text mb-0">
                                      Breaks down sales by meal periods (breakfast, lunch, dinner).
                                    </p>
                                    <p className="list-group-item-text mb-0">
                                      Includes total revenue, average transaction value, and customer counts.
                                    </p> */}
                                  </Link>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>

                        <div className="col-4 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body ">
                              <div className="row text-center">
                                <h4 className="mb-2">Menu Items</h4>
                              </div>
                              <div className="row">
                                <div className="list-group">
                                  <Link
                                    to="/reports_by_items_types"
                                    className="list-group-item"
                                  >
                                    <h5 className="list-group-item-heading mb-0">
                                      Item Sales
                                    </h5>
                                    <p className="list-group-item-text mb-0">
                                      View sales and quantity for each menu item.
                                    </p>

                                  </Link>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>

                        <div className="col-4 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body ">
                              <div className="row text-center">
                                <h4 className="mb-2">Orders</h4>
                              </div>
                              <div className="row">
                                <div className="list-group">
                                  <Link
                                    to="/reports_by_order_type"
                                    className="list-group-item"
                                  >
                                    <h5 className="list-group-item-heading mb-0">
                                      Order Summary
                                    </h5>
                                    <p className="list-group-item-text mb-0">
                                      View orders by status and payment method.
                                    </p>
                                  </Link>
                                </div>
                              </div>



                              {/* <div className="row my-1">
                                <div className="list-group">
                                  <Link
                                    to="/reports_by_due_amount"
                                    className="list-group-item"
                                  >
                                    <h5 className="list-group-item-heading mb-0">
                                      Due Amount Report
                                    </h5>
                                    <p className="list-group-item-text mb-0">
                                      Report by due amount
                                    </p>
                                  </Link>
                                </div>
                              </div> */}

                            </div>
                          </div>
                        </div>

                        <div className="col-4 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body ">
                              <div className="row text-center">
                                <h4 className="mb-2">Custom</h4>
                              </div>
                              <div className="row">
                                <div className="list-group">
                                  <Link
                                    to="/reports_by_custom_sales"
                                    className="list-group-item"
                                  >
                                    <h5 className="list-group-item-heading mb-0">
                                      Custom Report
                                    </h5>
                                    <p className="list-group-item-text mb-0">
                                      Generate sales reports for a custom date and time range.
                                    </p>


                                  </Link>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div className="col-4 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body ">
                              <div className="row text-center">
                                <h4 className="mb-2">Promotions</h4>
                              </div>
                              <div className="row">
                                <div className="list-group">
                                  <Link
                                    to="/reports_by_copoun_types"
                                    className="list-group-item"
                                  >
                                    <h5 className="list-group-item-heading mb-0">
                                      Promotion Performance
                                    </h5>
                                    <p className="list-group-item-text mb-0">
                                      View how promotions and discounts affected sales.
                                    </p>


                                  </Link>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>



                        <div className="col-4 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body ">
                              <div className="row text-center">
                                <h4 className="mb-2">Payments</h4>
                              </div>
                              <div className="row">
                                <div className="list-group">
                                  <Link
                                    to="/reports_by_payment_type"
                                    className="list-group-item"
                                  >
                                    <h5 className="list-group-item-heading mb-0">
                                      Payment Summary
                                    </h5>
                                    <p className="list-group-item-text mb-0">
                                      View payments by method and payment status.
                                    </p>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-4 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body ">
                              <div className="row text-center">
                                <h4 className="mb-2">Complimentary</h4>
                              </div>
                              <div className="row">
                                <div className="list-group">
                                  <Link
                                    to="/reports_by_nc_order"
                                    className="list-group-item"
                                  >
                                    <h5 className="list-group-item-heading mb-0">
                                      Complimentary Orders
                                    </h5>
                                    <p className="list-group-item-text mb-0">
                                      View orders provided without charge.
                                    </p>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-4 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body ">
                              <div className="row text-center">
                                <h4 className="mb-2">Staff</h4>
                              </div>
                              <div className="row">
                                <div className="list-group">
                                  <Link
                                    to="/reports_by_staff_order"
                                    className="list-group-item"
                                  >
                                    <h5 className="list-group-item-heading mb-0">
                                      Staff Performance
                                    </h5>
                                    <p className="list-group-item-text mb-0">
                                      View orders handled by each staff member.
                                    </p>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-4 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body ">
                              <div className="row text-center">
                                <h4 className="mb-2">On Hold</h4>
                              </div>
                              <div className="row">
                                <div className="list-group">
                                  <Link
                                    to="/reports_hold_order"
                                    className="list-group-item"
                                  >
                                    <h5 className="list-group-item-heading mb-0">
                                      Held Orders
                                    </h5>
                                    <p className="list-group-item-text mb-0">
                                      View orders that are currently on hold.
                                    </p>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>



                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Notification />
        </>
      )}
    </>
  );
};

export default Reports;
